import { ConnectedProps, connect } from 'react-redux';
import React, { FC } from 'react';
import { ReduxState } from '../../common/reducers';
import {
    ClaimLookupDto,
} from '../../Services/ClientProxy/clientProxy';
import './RepresentationClaims.scss';

const mapDispatchToProps = {};

const mapStateToProps = (state: ReduxState) => ({
    claimsCategory: state.referenceData?.taxpayersConfig?.claimsCategory,
    ConfigClaims: state.referenceData?.taxpayersConfig?.claims,
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export interface RepresentationClaimsProps {
    Claims?: ClaimLookupDto[];
    ClaimsCodes?: string[];
}

const RepresentationClaims: FC<RepresentationClaimsProps & PropsFromRedux> = (
    props: RepresentationClaimsProps & PropsFromRedux
) => {
    const { claimsCategory, ClaimsCodes, ConfigClaims, Claims } = props;
    const selectedUserClaims = ClaimsCodes?.length
        ? ConfigClaims?.filter((x) => ClaimsCodes.includes(x.code ?? ''))
        : Claims;

    return (
        <span className="representationClaims">
            {claimsCategory?.map((claimCategory) => {
                const userClaims = selectedUserClaims?.filter(
                    (claim) =>
                        claim?.parentCode &&
                        Number(claim.parentCode) === claimCategory.id
                );
                const userClaimslength = userClaims?.length ?? 0;
                return userClaimslength ? (
                    <>
                        <span className="bold">{claimCategory.name}</span>
                        <br />
                        {userClaims?.map((userClaim, index) => {
                            return (
                                <span>
                                    {userClaim.name}
                                    {userClaim.restrictedBranch ? '*' : ''}
                                    {userClaimslength - 1 !== index ? (
                                        ' , '
                                    ) : (
                                        <br />
                                    )}
                                </span>
                            );
                        })}
                        <br />
                    </>
                ) : (
                    <></>
                );
            })}
        </span>
    );
};
export default connector(RepresentationClaims);
